import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";

const getCoursesFinancialReport = (filter: string): AxiosPromise<CourseFinancialReportRow[]> => {
  return api.get<CourseFinancialReportRow[]>(endpoints.REPORTS.GET_COURSES_FINANCIAL_REPORT(filter));
};

const getCourseGroupsFinancialReport = (filter: string): AxiosPromise<CourseGroupFinancialReportRow[]> => {
  return api.get<CourseGroupFinancialReportRow[]>(endpoints.REPORTS.GET_COURSE_GROUPS_FINANCIAL_REPORT(filter));
};

const getSurveysCoursesReport = (filter: string): AxiosPromise<SurveysCoursesReportRow[]> => {
  return api.get<SurveysCoursesReportRow[]>(endpoints.REPORTS.GET_SURVEYS_COURSES_REPORT(filter));
};

const getSurveysCourseReport = (filter: string, courseId: number): AxiosPromise<SurveyCoursesReportRow[]> => {
  return api.get<SurveyCoursesReportRow[]>(endpoints.REPORTS.GET_SURVEYS_COURSE_REPORT(filter, courseId));
};

const getUserRegistrationsReport = (filter: string): AxiosPromise<UserRegistrationsReportRow[]> => {
  return api.get<UserRegistrationsReportRow[]>(endpoints.REPORTS.GET_USER_REGISTRATIONS(filter));
};

const getCourseRegistrationsByCourseReport = (filter: string): AxiosPromise<CourseRegistrationsByCourseRow[]> => {
  return api.get<CourseRegistrationsByCourseRow[]>(endpoints.REPORTS.GET_COURSE_REGISTRATIONS_BY_COURSE(filter));
};

const getPlaceCoursesReport = (filter: string): AxiosPromise<PlaceCoursesReportRow[]> => {
  return api.get<PlaceCoursesReportRow[]>(endpoints.REPORTS.GET_PLACE_COURSES_REPORT(filter));
};

export const reportsApi = {
  getCoursesFinancialReport,
  getCourseGroupsFinancialReport,
  getSurveysCoursesReport,
  getSurveysCourseReport,
  getUserRegistrationsReport,
  getCourseRegistrationsByCourseReport,
  getPlaceCoursesReport,
};

export interface CourseFinancialReportRow {
  courseId: number;
  courseName: string;
  totalIncome: number;
  totalExpense: number;
  netIncome: number;
}

export interface CourseGroupFinancialReportRow {
  courseGroupId: number;
  courseGroupName: string;
  totalIncome: number;
  totalExpense: number;
  netIncome: number;
}

export interface SurveysCoursesReportRow {
  courseRatingId: number;
  courseId: number;
  courseName: string;
  numberOfSurveys: number;
  averageRating: number;
}

export interface SurveyCoursesReportRow {
  courseRatingId: number;
  rating: number;
  comment: string;
  userId: number;
  userEmail: string;
  createdDate: Date;
}

export interface UserRegistrationsReportRow {
  userId: number;
  userEmail: string;
  firstName: string;
  surname: string;
  createdDate: Date;
  pesel: string;
  phone: string;
}

export interface CourseRegistrationsByCourseRow {
  courseId: number;
  courseName: string;
  numberOfRegistrations: number;
}
export interface PlaceCoursesReportCourseRow {
  courseId: number;
  courseName: string;
  numberOfEvents: number;
}

export interface PlaceCoursesReportRow {
  placeId: number;
  placeName: string;
  numberOfEvents: number;
  numberOfCourses: number;
  courses: PlaceCoursesReportCourseRow[];
}
